import {Component} from '@angular/core';

/**
 * User menu selection UI
 * This component works along with epg-user-menu-navigation and epg-user-menu-navigation-fullscreen.
 * This component displays the user menu options for the user menu navigation.
 *
 * @example
 *
    <epg-user-menu-selection>
        <button epg-button [shape]="'text'" epg-button-icon class="button-option">
          <span class="icon fa-pencil far"></span>
          <span>Update profile</span>
        </button>

        <button epg-button [shape]="'text'" epg-button-icon class="button-option">
          <span class="icon fa-gear far"></span>
          <span>Parameters</span>
        </button>

        <div class="card-footer">
          <button epg-button [shape]="'text'" epg-button-icon class="button-option">
              <span class="icon far fa-right-from-bracket"></span>
              <span>Logout</span>
            </button>
        </div>
    </epg-user-menu-selection>
 */

@Component({
  selector: 'epg-user-menu-selection',
  imports: [],
  templateUrl: './epg-user-menu-selection.component.html',
  styleUrl: './epg-user-menu-selection.component.scss',
})
export class EpgUserMenuSelectionComponent {}
